import { createStore } from '@stencil/store'
import { IIndividualCue } from 'src/call/types'

import { useLogging } from '../../../utils/logging'

export const CommentStore = createStore({
  selectedCue: null as IIndividualCue,
  isUpdating: false,
})

// const { state, onChange } = CommentStore

CommentStore.use(useLogging('Comment'))
